/**
 * Domain Configuration
 * This file is auto-generated based on the DOMAIN_NAME environment variable
 * Used to replace {{DOMAIN_NAME}} placeholders in locale files
 * 
 * Generated at: 2026-01-29T13:40:39.359Z
 */

// Domain name from environment variable (set at build time)
export const DOMAIN_NAME = 'trans-treffen.de'

export default DOMAIN_NAME
